import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Login from "./Components/Login";
import PromptFlow from "./Pages/PromptFlow"; // The main app
import PrivateRoute from "./Components/PrivateRoute"; // Import PrivateRoute
import { auth } from "./utils/firebase"; // Firebase auth

function App() {
  const [user, setUser] = useState(null);

  // Monitor authentication state
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((currentUser) => {
      setUser(currentUser); // Update the user state
    });
    return () => unsubscribe(); // Cleanup the listener on unmount
  }, []);

  return (
    <BrowserRouter
      future={{
        v7_startTransition: true, // Opt-in for React Router v7 startTransition behavior
        v7_relativeSplatPath: true, // Opt-in for React Router v7 relative splat path behavior
      }}
    >
      <Routes>
        {/* Public Route */}
        <Route path="/login" element={<Login />} />

        {/* Protected Route */}
        <Route
          path="/PromptFlow"
          element={
            <PrivateRoute user={user}>
              <PromptFlow />
            </PrivateRoute>
          }
        />

        {/* Default Route */}
        <Route path="/" element={<Navigate to="/login" />} />

        {/* Fallback Route for unmatched paths */}
        <Route path="*" element={<Navigate to="/login" />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;